import { ProjectSortKeys, TipIdKeys } from '../../../../../responses/projects'
import { TaskStatus } from '../../../../../constants/enums'
import { RefIntersection } from '../../../../../responses/refs/refs'

export const sortFilters: {
    key: ProjectSortKeys,
    name: string,
}[] = [
    {
        key: 'code',
        name: 'По номеру'
    }, {
        key: 'opened_at',
        name: 'По дате создания',
    }, {
        key: 'short_name',
        name: 'По названию',
    }, {
        key: 'status_id',
        name: 'По статусу',
    }, {
        key: 'priority',
        name: 'По приоритету',
    }, {
        key: 'last_comment',
        name: 'По дате комментирования',
    }
]
export const DesignProductionFilters: {
    key: number,
    name: string,
}[] = [
    {
        key: 1,
        name: 'Выигрыш',
    }, {
        key: 2,
        name: 'Проигрыш',
    }, {
        key: 3,
        name: 'Отмена',
    }
]
export const taskStatusFilters = [
    {
        key: TaskStatus.ALL,
        name: 'Любые задачи',
    }, {
        key: TaskStatus.OPENED,
        name: 'Открытые',
    }, {
        key: TaskStatus.CLOSED,
        name: 'Закрытые',
    }, {
        key: TaskStatus.REQUESTED,
        name: 'Запросы на открытие',
    }
]

type Renderer = (ref: RefIntersection) => string

export interface RefLine {
    key: TipIdKeys,
    placeholder: string,
    render: Renderer,
    empty?: string,
    multi: boolean,
}

export const refsConfig: RefLine[] = [
    {
        key: 'client',
        placeholder: 'Клиент',
        render: client => client.short_title,
    } as RefLine, {
        key: 'work_object',
        placeholder: 'Объект',
        multi: true,
        //render: work_object_type => `${work_object_type.work_object?.name} (${work_object_type.name})`
        render: work_object_type => `${work_object_type.name}`
    } as RefLine, {
        key: 'manager',
        placeholder: 'Менеджер',
        render: manager => manager.name,
    } as RefLine, {
        key: 'brand',
        placeholder: 'Бренд',
        render: brand => brand.title,
    } as RefLine, {
        key: 'tasks_type',
        placeholder: 'Тип задач',
        render: type => type.name,
    } as RefLine, {
        key: 'tasks_target_user',
        placeholder: 'Исполнитель',
        render: user => user.name,
        empty: 'Не назначен',
    } as RefLine, {
        key: 'network',
        placeholder: 'Издание',
        render: network => network.name,
        empty: 'Без издания',
    } as RefLine, {
        key: 'work_type',
        placeholder: 'Тип',
        render: type => type.code + ' - ' + type.name,
        empty: 'Без типа',
    } as RefLine, {
        key: 'country',
        placeholder: 'Страна',
        render: country => country.code,
        empty: 'Не выбрана',
    } as RefLine, {
        key: 'object_curator',
        placeholder: 'Куратор',
        render: curator => curator.name,
        empty: 'Без куратора'
    } as RefLine
]